import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditGDSR = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [entry, setEntry] = useState({ ...state.entry, token_id: state.entry.token_id });
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'aruid') {
            return '/arms-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/dsr-dashboard';
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-gdsr.php', {
                action: 'update',
                ...entry,
            });

            if (response.data?.status === 'success') {
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                    navigate(getDashboardUrl());
                }, 2000);
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form">
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">DSR No.:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="dsr_no"
                                value={entry.dsr_no}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={entry.date}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Subject:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="subject"
                                value={entry.subject}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Statement:</label>
                        <div className="lc-input-container">
                            <input
                                name="statement"
                                value={entry.statement}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Sabotage:</label>
                        <div className="lc-input-container">
                            <input
                                name="sabotage"
                                value={entry.sabotage}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Crime:</label>
                        <div className="lc-input-container">
                            <input
                                name="crime"
                                value={entry.crime}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Politics:</label>
                        <div className="lc-input-container">
                            <input
                                name="politics"
                                value={entry.politics}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Religious:</label>
                        <div className="lc-input-container">
                            <input
                                name="religious"
                                value={entry.religious}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Strikes:</label>
                        <div className="lc-input-container">
                            <input
                                name="strikes"
                                value={entry.strikes}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Incidents:</label>
                        <div className="lc-input-container">
                            <input
                                name="incidents"
                                value={entry.incidents}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Recovery:</label>
                        <div className="lc-input-container">
                            <input
                                name="recovery"
                                value={entry.recovery}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Miscellaneous:</label>
                        <div className="lc-input-container">
                            <input
                                name="miscellaneous"
                                value={entry.miscellaneous}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Events:</label>
                        <div className="lc-input-container">
                            <input
                                name="events"
                                value={entry.events}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">VIPs:</label>
                        <div className="lc-input-container">
                            <input
                                name="arrival"
                                value={entry.arrival}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Intelligence:</label>
                        <div className="lc-input-container">
                            <input
                                name="intelligence"
                                value={entry.intelligence}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Raids:</label>
                        <div className="lc-input-container">
                            <input
                                name="raids"
                                value={entry.raids}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Operation:</label>
                        <div className="lc-input-container">
                            <input
                                name="operation"
                                value={entry.operation}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Narcotics:</label>
                        <div className="lc-input-container">
                            <input
                                name="narcotics"
                                value={entry.narcotics}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Rains:</label>
                        <div className="lc-input-container">
                            <input
                                name="rains"
                                value={entry.rains}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="lc-form-buttons">
                <button type="button" className="lc-submit-btn" onClick={handleSave}>
                    Update
                </button>
                <button type="button" className="lc-cancel-btn" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
            </form>
            
            {error && <div className="lc-error-message">{error}</div>}
            {showPopup && (
                <div className="lc-popup">
                    Entry updated successfully!
                </div>
            )}
        </div>
    );
};

export default EditGDSR;